<script lang="ts">
  import SmallGhostButton from '@/ui/elements/buttons/SmallGhostButton.svelte';

  let {
    onTextFormatClick,
    onUndoClick,
    onRedoClick,
    onListClick,
    undoDisabled,
    redoDisabled,
    disabled,
  } = $props();
</script>

<div class="fr-cs gap-2 border-b border-b-c-divider pb-4">
  <SmallGhostButton
    icon="Undo"
    label="Undo"
    onclick={onUndoClick}
    disabled={undoDisabled || disabled}
  ></SmallGhostButton>
  <SmallGhostButton
    icon="Redo"
    label="Redo"
    onclick={onRedoClick}
    disabled={redoDisabled || disabled}
  ></SmallGhostButton>
  <div class="grow"></div>
  <SmallGhostButton icon="Bold" label="Bold" onclick={() => onTextFormatClick('bold')} {disabled}
  ></SmallGhostButton>
  <SmallGhostButton
    icon="Italic"
    label="Italic"
    onclick={() => onTextFormatClick('italic')}
    {disabled}
  ></SmallGhostButton>
  <SmallGhostButton
    icon="Underline"
    label="Underline"
    onclick={() => onTextFormatClick('underline')}
    {disabled}
  ></SmallGhostButton>
  <div class="h-4 w-0 border-l border-c-divider-darker"></div>
  <SmallGhostButton icon="Bullets" label="List" onclick={onListClick} {disabled}></SmallGhostButton>
</div>
